import { CellAction } from "./cell-action";

import { User } from "@/src/data/types";
import { ColumnDef } from "@tanstack/react-table";
import { Badge } from "../../ui/badge";

export const columns: ColumnDef<User>[] = [
  {
    accessorKey: "fullName",
    header: "NOM & PRENOM",
    cell: ({ row }) => (
      <span>
        {row.original.firstName} {row.original.lastName}
      </span>
    ),
  },
  {
    accessorKey: "email",
    header: "EMAIL",
  },
  {
    accessorKey: "role",
    header: "ROLE",
  },
  {
    accessorKey: "isDeleted",
    header: "STATUS",

    cell: ({ row }) => {
      return (
        <Badge
          className={`${
            row.original.isDeleted === false ? "bg-green-500" : "bg-red-500"
          } `}
        >
          {row.original.isDeleted === false ? "Active" : "Inactive"}
        </Badge>
      );
    },
  },

  {
    accessorKey: "actions",
    header: "ACTIONS",
    id: "actions",
    cell: ({ row }) => <CellAction data={row.original} />,
  },
];
